import { render, staticRenderFns } from "./design_new_.vue?vue&type=template&id=a4323fa2&scoped=true"
import script from "./design_new_.vue?vue&type=script&lang=js"
export * from "./design_new_.vue?vue&type=script&lang=js"
import style0 from "./design_new_.vue?vue&type=style&index=0&id=a4323fa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4323fa2",
  null
  
)

export default component.exports